import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import { api, setAuth } from "../lib/api";
import { Input } from "../components/ui/input";
import { Button } from "../components/ui/button";
import { Label } from "../components/ui/label";
import { Loader2 } from "lucide-react";

const LOGO_URL = "https://customer-assets.emergentagent.com/job_f8301de4-2106-462d-b07e-224b65c4a393/artifacts/6lhdxzim_Cor.png";

export default function Login() {
  const [email, setEmail] = useState("info@atlantic4web.pt");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const nav = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const { data } = await api.post("/auth/login", { email, password });
      setAuth(data.token, data.user);
      toast.success(`Bem-vindo, ${data.user.name}`);
      nav("/dashboard");
    } catch (err) {
      toast.error(err?.response?.data?.detail || "Falha no login");
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="min-h-screen grid grid-cols-1 lg:grid-cols-2" data-testid="login-page">
      <div className="hidden lg:flex flex-col justify-between p-12 text-white" style={{ background: "linear-gradient(160deg, #0F172A 0%, #1E3A8A 60%, #172554 100%)" }}>
        <img src={LOGO_URL} alt="Atlantic4Web" className="w-32" />
        <div>
          <p className="a4w-label" style={{ color: "#94a3b8" }}>Plataforma de Gestão</p>
          <h2 className="text-4xl xl:text-5xl font-bold tracking-tight mt-2 leading-tight">Gestão simples para a sua agência web.</h2>
          <p className="mt-4 text-slate-300 max-w-md">Clientes, serviços, notas de encomenda e alertas de renovação — tudo num só lugar.</p>
        </div>
        <p className="text-xs text-slate-400">© {new Date().getFullYear()} Atlantic4Web — Creative Agency</p>
      </div>

      <div className="flex items-center justify-center p-8 bg-white">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <div className="lg:hidden mb-8 text-center">
            <img src={LOGO_URL} alt="Atlantic4Web" className="h-20 mx-auto" />
          </div>
          <p className="a4w-label">Acesso restrito</p>
          <h1 className="text-3xl font-bold tracking-tight mt-1 mb-6">Iniciar Sessão</h1>

          <div className="space-y-4">
            <div>
              <Label htmlFor="email">Email</Label>
              <Input id="email" type="email" required value={email} onChange={(e) => setEmail(e.target.value)} data-testid="login-email" />
            </div>
            <div>
              <Label htmlFor="password">Password</Label>
              <Input id="password" type="password" required value={password} onChange={(e) => setPassword(e.target.value)} data-testid="login-password" />
            </div>
          </div>
          <Button type="submit" disabled={loading} className="w-full mt-6 h-11 bg-[#1E3A8A] hover:bg-[#172554]" data-testid="login-submit">
            {loading ? <Loader2 className="animate-spin" size={18} /> : "Entrar"}
          </Button>
          <p className="text-xs text-slate-500 mt-6">Não tem acesso? Contacte o administrador.</p>
        </form>
      </div>
    </div>
  );
}
